import {
  ArrowRightIcon,
  BanknotesIcon,
  ChartBarSquareIcon,
  ChatBubbleLeftRightIcon,
} from "@heroicons/react/24/solid";
import {
  Stack,
  Title,
  Text,
  Paper,
  Grid,
  Avatar,
  Button,
  Flex,
} from "@mantine/core";
import { Link } from "@tanstack/react-router";

export const NotYetACustomer = () => {
  return (
    <Stack p={"lg"}>
      <Title order={2} ff={"var(--wallet-font-family-subjecttivity)"}>
        Du verkar inte vara kund hos oss än!
      </Title>
      <Text>
        För att kunna logga in behöver du vara kund hos oss. Innan du blir kund
        hos oss så måste vi få lite information om dig och ditt sparande. Det
        tar bara några minuter!
      </Text>
      <Paper p={30} radius={"24px"} mb={"2rem"}>
        <Grid mb={"xl"}>
          <Grid.Col span={4}>
            <Avatar radius="xl" mb={"sm"}>
              <BanknotesIcon
                height={21}
                color="var(--wallet-color-primary-shade-700)"
              />
            </Avatar>
            <Title order={5}>Lägre avgifter</Title>
            <Text c={"var(--wallet-color-neutrals-gray-600)"}>
              Genom att bli av med onödiga avgifter kan du spara upp till 1
              miljon mer tills du går i pension!
            </Text>
          </Grid.Col>
          <Grid.Col span={4}>
            <Avatar radius="xl" mb={"sm"}>
              <ChartBarSquareIcon
                height={21}
                color="var(--wallet-color-primary-shade-700)"
              />
            </Avatar>
            <Title order={5}>Överskådligt sparande</Title>
            <Text c={"var(--wallet-color-neutrals-gray-600)"}>
              När du samlar din pension hos oss kan du enkelt se hur dina pengar
              växer över tid.
            </Text>
          </Grid.Col>
          <Grid.Col span={4}>
            <Avatar radius="xl" mb={"sm"}>
              <ChatBubbleLeftRightIcon
                height={21}
                color="var(--wallet-color-primary-shade-700)"
              />
            </Avatar>
            <Title order={5}>Individuell rådgivning</Title>
            <Text c={"var(--wallet-color-neutrals-gray-600)"}>
              Våra råd är skräddarsydda till just din ekonomi och dina önskemål.
              Allt för att du ska känna dig trygg i ditt sparande.
            </Text>
          </Grid.Col>
        </Grid>
        <Link to="/signup">
          <Button fullWidth mb={"md"}>
            Förbättra min pension{" "}
            <Flex ml={"sm"} align={"center"}>
              <ArrowRightIcon height={16} />
            </Flex>
          </Button>
        </Link>
        <Button fullWidth variant="outline">
          Nej tack!
        </Button>
      </Paper>
    </Stack>
  );
};
